import { useCallback, useEffect, useState } from 'react';
import { dateFormatter, getCurrentDateTime, request, toast } from '../../../../../../utils';
import { IconButton, Stack, Typography, TextField as MuiTextField } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Table } from '../../../../../../components';



function formatDate(dateString) {
    const date = new Date(dateString);

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
}

const TABLE_HEADER = [
    { header: 'IPD No.', accessor: 'ipd_no' },
    { header: 'UHID No.', accessor: 'uhid' },
    { header: 'Patient Name', accessor: (row) => `${row.patient.first_name} ${row.patient.last_name}` },
    {
        header: 'Admission Date', accessor: (row) => `${formatDate(row?.admissionDate)}`
    },
    { header: 'Address', accessor: 'patient.address.address' },
    { header: 'Sponsor', accessor: 'patient.sponsor.name' },
    { header: 'Mobile No.', accessor: 'patient.address.mobile' }
];

export const IpdSearchHandlerDischargeSummary = ({ onClose, onAdd }) => {
    const [ipdSearchList, setIpdSearchList] = useState([]);
    const [input, setInput] = useState('')
    const [patientData, setPatientData] = useState([])
    const [isFiltered, setIsFiltered] = useState(false)

    const getIPDSearchDetailList = useCallback(async () => {
        try {
            const response = await request('/indoor-registeration-detail-list', { method: 'GET' });
            if (response?.success) {
                const filteredData = (response.data || [])
                const sortedData = filteredData.sort((a, b) => new Date(b.admissionDate) - new Date(a.admissionDate));
                setIpdSearchList(sortedData);
                setPatientData(sortedData)
            } else {
                toast('Failed to load IPD registration list');
            }
        } catch (error) {
            toast('An error occurred while fetching the data');
        }
    }, []);

    useEffect(() => {
        getIPDSearchDetailList();
    }, [getIPDSearchDetailList]);


    useEffect(() => {
        if (ipdSearchList.data && ipdSearchList.data.length > 0) {
            setIpdSearchList(ipdSearchList.data);
            setIsFiltered(false);
        }
    }, [ipdSearchList]);

    const handlePatientData = () => {
        const lowercasedInput = input.toLowerCase();
        const filtered = ipdSearchList.filter((item) =>
            item.ipd_no?.toString().toLowerCase().includes(lowercasedInput) ||
            item?.patient?.first_name?.toLowerCase().includes(lowercasedInput)
        );
        setPatientData(filtered);
    };

    const handleChange = (e) => {
        const newInput = e.target.value;
        setInput(newInput);
        handlePatientData();
    }

    return (
        <>
            <Stack
                direction="row"
                spacing={2}
                alignItems="center"
                justifyContent="space-between"
                borderBottom="1px solid"
                borderColor="grey.300"
            >
                <Typography variant="h4" fontWeight="bold">
                    Indoor Registeration Search
                </Typography>
                <IconButton onClick={onClose}>
                    <CloseIcon color="error" fontSize="large" />
                </IconButton>
            </Stack>
            <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 0 }}>
                <MuiTextField
                    sx={{
                        width: '100%',
                        '& .MuiOutlinedInput-root': {
                            padding: '0',
                            fontSize: '1.4rem' // Adjust input font size
                        },
                        '& .MuiOutlinedInput-input': {
                            padding: '8px 1.4rem'
                        },
                        '& .MuiInputLabel-root': {
                            fontSize: '1.2rem' // Adjust label font size
                        }
                    }}
                    label="Search Patient"
                    variant="outlined"
                    value={input}
                    onChange={handleChange}
                />
            </Stack>
            <Table
                sx={{ mt: 0.5 }}
                columns={TABLE_HEADER}
                data={patientData || []}
                onRowClick={(row) => {
                    onAdd(row.ipd_no);
                    onClose();
                }}
            />
        </>
    );
};
